const CONSTANTS = {
  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
  FACEBOOK_VERSION: process.env.REACT_APP_FACEBOOK_VERSION,
  APPLE_CLIENT_ID: process.env.REACT_APP_APPLE_CLIENT_ID,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI,
};
export default CONSTANTS